// 初始状态
const state = {
  items: JSON.parse(localStorage.getItem('cart') || '[]'),
  checkoutStatus: null
}

// 获取器
const getters = {
  cartItems: state => state.items,
  cartItemCount: state => state.items.reduce((count, item) => count + item.quantity, 0),
  cartTotalPrice: state => state.items.reduce((total, item) => {
    return total + (item.price * item.quantity)
  }, 0)
}

// 动作
const actions = {
  // 添加商品到购物车
  addToCart({ commit, state }, { shoe, quantity = 1 }) {
    const cartItem = state.items.find(item => item.id === shoe.id)
    
    if (cartItem) {
      // 如果商品已在购物车中，更新数量
      commit('updateCartItem', {
        id: shoe.id,
        quantity: cartItem.quantity + quantity
      })
    } else {
      // 否则添加新商品
      commit('addCartItem', {
        id: shoe.id,
        title: shoe.title,
        price: shoe.price || 0, // 防止价格为null
        image: shoe.images[0]?.url || '',
        quantity
      })
    }
    
    // 保存到本地存储
    localStorage.setItem('cart', JSON.stringify(state.items))
  },
  
  // 从购物车移除商品
  removeFromCart({ commit, state }, itemId) {
    commit('removeCartItem', itemId)
    // 保存到本地存储
    localStorage.setItem('cart', JSON.stringify(state.items))
  },
  
  // 更新购物车商品数量
  updateItemQuantity({ commit, state }, { id, quantity }) {
    if (quantity > 0) {
      commit('updateCartItem', { id, quantity })
      // 保存到本地存储
      localStorage.setItem('cart', JSON.stringify(state.items))
    } else {
      // 如果数量为0或负数，移除商品
      commit('removeCartItem', id)
      localStorage.setItem('cart', JSON.stringify(state.items))
    }
  },
  
  // 清空购物车
  clearCart({ commit }) {
    commit('setItems', [])
    // 清除本地存储
    localStorage.removeItem('cart')
  },
  
  // 结算
  checkout({ commit }) {
    commit('setCheckoutStatus', 'successful')
    
    // 在实际应用中，这里应该调用API来创建订单
    
    // 清空购物车
    commit('setItems', [])
    localStorage.removeItem('cart')
  }
}

// 变更
const mutations = {
  setItems(state, items) {
    state.items = items
  },
  
  addCartItem(state, item) {
    state.items.push(item)
  },
  
  updateCartItem(state, { id, quantity }) {
    const item = state.items.find(item => item.id === id)
    if (item) {
      item.quantity = quantity
    }
  },
  
  removeCartItem(state, id) {
    state.items = state.items.filter(item => item.id !== id)
  },
  
  setCheckoutStatus(state, status) {
    state.checkoutStatus = status
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
} 